export const Routes = {
  HomePage: '/',
  Account: '/account',
  History: '/history',
  Search: '/search',
  AssociationAid: '/:aidType/association/:consumptionPoint',
  AssociationAddition: '/:aidType/association-addition/:consumptionPoint',
  Aid: '/:aidType/aids/:consumptionPoint',
  Addition: '/:aidType/additions/:consumptionPoint',
  AidsSearch: '/:aidType/aids',
  AdditionSearch: '/:aidType/additions',
  PaymentReports: '/payment-reports',
  PaymentReportsAddition: '/payment-reports-addition',
  Report: '/report',
  BlockMonth: '/block-month',
  BillAids: '/bill-aids',
  BillAdditions: '/bill-additions',
  Export: '/export',
  BackOfficeAssociation: '/association/:consumptionPoint',
  BackOfficeAdditionAssociation: '/addition-association/:consumptionPoint',
  BackOfficeComputation: '/computation/:consumptionPoint',
  BackOfficeAdditionComputation: '/addition-computation/:consumptionPoint',
  FileImport: '/file-import',
  FileImportAdditions: '/import-additions',
  FileImportAJPIS: '/ajpis/file-import',
  FileImportAdditionsAJPIS: '/ajpis/import-additions',
  ForgetPassword: '/forgot/:id/:token',
  LoginPath: '/(home|login|)/',
  Login: '/login',
  Home: '/home',
  PartnerExport: '/partner-export'
};

export const AidType = {
  ElectricEnergy: 'electric-energy',
  NaturalGas: 'natural-gas'
};